import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import {Link} from "react-router-dom";
import Img from "../../img/slider.jpg";
import React from "react";

const HeroSlider = () => {
    return (
        <section>
            <Swiper
                spaceBetween={10}
                slidesPerView={1}
                navigation={true}
                modules={[Navigation]}
                style={{
                    "--swiper-navigation-size": "16px",
                }}
            >
                {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                <SwiperSlide><Link to={'/'}><img src={Img} alt="Slider Image" /></Link></SwiperSlide>
                {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                <SwiperSlide><Link to={'/'}><img src={Img} alt="Slider Image" /></Link></SwiperSlide>
            </Swiper>
        </section>
    )
}
export default HeroSlider;